<template>
  <div style="display: none;"></div>
</template>

<script>
import { getBreadcrumbs, injectJsonLd } from '@/schema.config';

export default {
  name: 'CommonBreadCrumbSchemaComponent',
  methods: {
    update() {
      injectJsonLd('breadcrumb-schema', getBreadcrumbs(this.$route.path));
    },
  },
  watch: {
    '$route'() { this.update(); },
  },
  mounted() {
    this.update();
  },
};
</script>
